<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="回答内容"
                      v-model="listQuery.entity.answer.content">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="问题id"
                      v-model="listQuery.entity.answer.questionId">
            </el-input>
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.entity.answer.status"
                       placeholder="状态">
                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>
            <el-date-picker
                    @change='handleFilter'
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="filter-item input"
                    v-model="listQuery.entity.answer.times"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="回答时间开始日期"
                    end-placeholder="回答时间结束日期">
            </el-date-picker>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave" icon="el-icon-edit">添加
                </el-button>
                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                           @click="handleDownload">导出
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <yf-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.answer.id}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="回答内容">
                <template slot-scope="scope">
                    <span v-if="scope.row.answer">{{scope.row.answer.content}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="问题id">
                <template slot-scope="scope">
                    <span v-if="scope.row.answer">{{scope.row.answer.questionId}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="状态">
                <template slot-scope="scope">
                                                <span v-if="scope.row.answer">

                         <el-tag :type="tagTypes[scope.row.answer.status]" v-if="scope.row.answer.status!=null">     {{statusOptions[scope.row.answer.status]}}</el-tag>

                        </span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="回答时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.answer">{{parseTime(scope.row.answer.time)}}</span>
                </template>
            </yf-table-column>

            <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </yf-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="回答内容" prop="answer.content">
                    <el-input v-model="temp.answer.content"></el-input>
                </el-form-item>
                <el-form-item label="问题id" prop="answer.questionId">
                    <el-input v-model="temp.answer.questionId"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="answer.status">
                    <el-select class="filter-item" v-model="temp.answer.status" placeholder="状态">
                        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="回答时间" prop="answer.time">
                    <el-date-picker v-model="temp.answer.time" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="回答时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="回答图" prop="answer.img">
                    <el-upload
                            ref="imgUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="imgList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(imgList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(imgList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, options, down, info, save, update, remove} from '@/api/answer'
    import waves from '@/directive/waves' // 水波纹指令
    import {downExcel} from '@/utils/down.js'
    import {parseTime} from '@/utils'

    import {getToken, domain} from '@/api/qiniu'
    import {listToStrs, strsToList} from '@/utils/imgUtil'

    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                time: null
                ,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'answer.id desc',
                    entity: {
                        answer:
                            {
                                id: null, img: null, content: null, time: null, questionId: null, status: null
                            }
                    }
                },
                statusOptions: [],
                tagTypes: ['info', '', 'warning', 'danger', 'warning'],
                temp: {

                    answer:
                        {
                            id: null, img: null, content: null, time: null, questionId: null, status: null
                        }


                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                // 存在图片
                dialogImageUrl: '',
                dialogVisible: false,
                imgList: [],
                rules:
                    {
                        'answer.img': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'answer.content': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'answer.time': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'answer.questionId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'answer.status': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'blur'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key: ''
                    }
            }
        },
        created() {
            this.getList()
            this.getOptions()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'answer:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'answer:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'answer:update')
            },
            canList() {
                return hasAuth(this.perms, 'answer:list')
            }
        },
        methods: {
            parseTime(time) {
                if (!time) return ''
                return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
            },
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.listLoading = false
                })
            },
            getOptions() {
                options().then(res => {
                    this.statusOptions = res.data.statusOptions
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()

                // 存在图片字段转换图片地址显示
                this.initImgUrl()
            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
                this.initImgName()// 图片转换
            },
            resetTemp(row) {

                this.temp = {
                    answer: {}
                }
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            // 显示将图片名封装成可以展示状态集合
            initImgUrl() {
                this.imgList = strsToList(this.temp.answer.img, domain)
            },
            // 关闭显示窗口 重置图片地址 防止错乱
            resetImgUrl() {
                this.imgList = []
            },
            // 上传或者更新的时候从图片链接中获取图片名字
            initImgName() {
                this.temp.answer.img = listToStrs(this.imgList)
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()

                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.answer.id]
                const ids = [this.list[this.index].answer.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.answer.id).then(res => {
                    this.temp = res.data
                    this.dialogStatus = 'update'
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs['dataForm'].clearValidate()
                    })
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                // this.list.splice(this.index, 1, this.temp)
                                this.getList()
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                // 存在图片
                this.resetImgUrl()
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                down(this.listQuery).then(res => {
                    downExcel(res)
                    this.downloadLoading = false
                    this.$notify({
                        title: '成功',
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
            // 存在图片
            handleUpload(file) {
                this.qData.key = new Date().valueOf() + file.name
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).catch(error => {
                    console.log(error)
                })
            },
            handleImgUploadSuccess(imgList, file) {
                imgList.push({name: file.response.key, url: domain + file.response.key})
            },
            handleImgRemove(imgList, file) {
                for (var fn of imgList) {
                    if (fn.name === file.name) {
                        imgList.splice(imgList.indexOf(fn), 1)
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        }
    }
</script>
